"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchMethod = exports.ComponentType = exports.DispatchState = void 0;
var DispatchState;
(function (DispatchState) {
    DispatchState["CREATED"] = "CREATED";
    DispatchState["SENT"] = "SENT";
    DispatchState["DELIVERED"] = "DELIVERED";
})(DispatchState = exports.DispatchState || (exports.DispatchState = {}));
/**
 * Typ komponenty
 */
var ComponentType;
(function (ComponentType) {
    ComponentType["MAIN"] = "MAIN";
    ComponentType["DELIVERY_NOTE"] = "DELIVERY_NOTE";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
/**
 * Spůsob doručení
 */
var DispatchMethod;
(function (DispatchMethod) {
    DispatchMethod["EMAIL"] = "EMAIL";
    DispatchMethod["DATABOX"] = "DATABOX";
    DispatchMethod["POSTAL"] = "POSTAL";
})(DispatchMethod = exports.DispatchMethod || (exports.DispatchMethod = {}));
//# sourceMappingURL=ess-types.js.map